import { gql } from '@apollo/client';

const ValidateSignedLink = gql`
  query validateSignedLink($signed_link: SignedLink!, $version: Int) {
    validateSignedLink(signedLink: $signed_link, version: $version) {
      valid
      error
      email
      isEmailEditable
    }
  }
`;

export default ValidateSignedLink;
